<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title>
          <v-btn
            dark
            color="secondary"
            class="ma-2"
            outlined
            @click="$router.back()"
          >
            <v-icon>mdi-arrow-left</v-icon>
            Back
          </v-btn>
        </v-card-title>
        <v-card-title class="pl-6">Course Item</v-card-title>
        <div class="pa-5">
          <v-form ref="form">
            <v-text-field
              label="Header"
              outlined
              :rules="[requiredRule]"
              prepend-icon="mdi-text"
              v-model="item.header"
              color="primary"
            ></v-text-field>
            <v-select
              label="Item Type"
              :items="getItemTypes"
              item-text="name"
              item-value="id"
              prepend-icon="mdi-format-list-bulleted-square"
              outlined
              :rules="[requiredRule]"
              v-model="item.item_type_id"
            ></v-select>
            <div class="d-flex mb-8 pb-2">
              <v-icon class="pr-2 html-icon">mdi-text</v-icon>
              <div class="w-full pl-1">
                <div class="mb-3 label grey--text">Content</div>

                <HtmlEditor
                  v-model="item.body_text"
                  placeholder="Write something..."
                  :className="
                    item.required ? 'html-body-error w-100 mt-2' : 'w-100 mt-2'
                  "
                ></HtmlEditor>
              </div>
            </div>
            <v-text-field
              label="Order"
              type="number"
              v-model="item.order"
              prepend-icon="mdi-numeric"
              outlined
            />
            <v-select
              label="Parent Course Item"
              :items="parents"
              item-text="label"
              item-value="value"
              prepend-icon="mdi-format-list-bulleted-square"
              outlined
              v-model="item.parent_id"
            ></v-select>
            <v-text-field
              label="Minimum Time (Seconds)"
              type="number"
              v-model="item.minimum_time"
              prepend-icon="mdi-numeric"
              outlined
            />
            <v-select
              label="Video Check"
              :items="videoCheckItems"
              prepend-icon="mdi-format-list-bulleted-square"
              outlined
              v-model="item.video_check"
            ></v-select>
            <v-row class="mt-5" justify="end">
              <v-btn
                color="primary"
                @click="save"
                :disabled="loading"
                :loading="loading"
              >
                {{ isCreate ? "Create Item" : "Save changes" }}
              </v-btn>
            </v-row>
          </v-form>
        </div>
      </base-card>
    </v-col>
  </v-row>
</template>

<script>
import HtmlEditor from "@/components/HtmlEditor";
import { convertObjectToFormData } from "@/shared/utils";
import { find, get, omit } from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo: {
    title: "Course Item",
  },
  components: { HtmlEditor },
  async mounted() {
    this.getItemTypes.length ? this.getItemTypes : await this.getAllItemTypes();
    this.getCourseParentItems.length
      ? this.getCourseParentItems
      : await this.getAllParentItems();

    if (this.itemId) {
      this.item = omit(find(this.getCourseItems, { id: +this.itemId }), ["id"]);
    }
  },
  data() {
    return {
      id: get(this.$route, "params.id"),
      itemId: get(this.$route, "params.itemId"),
      loading: false,
      item: {
        header: null,
        item_type_id: null,
        body_text: "",
        order: 0,
        parent_id: 0,
        minimum_time: 0,
        video_check: 0,
      },
      videoCheckItems: [
        {
          text: "Yes",
          value: 1,
        },
        {
          text: "No",
          value: 0,
        },
      ],
      requiredRule: (v) => !!v || "This is required.",
      emailRule: (v) =>
        !!v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid",
    };
  },
  methods: {
    ...mapActions([
      "showSnackbar",
      "setItemTypes",
      "setCourseParentItems",
      "createCourseItem",
      "updateCourseItem",
    ]),

    async getAllItemTypes() {
      return await this.setItemTypes();
    },

    async getAllParentItems() {
      return await this.setCourseParentItems({ id: this.course.id });
    },

    async save() {
      this.loading = true;

      if (!this.$refs.form.validate()) {
        this.$store.dispatch("showSnackbar", "One or more fields are invalid.");
        this.loading = false;

        return;
      }

      let payload = convertObjectToFormData(this.item);
      payload.set("course_id", this.course.id);

      try {
        this.isCreate
          ? await this.createCourseItem(payload)
          : await this.updateCourseItem({ id: this.itemId, payload });

        this.loading = false;
        this.$store.dispatch(
          "showSnackbar",
          `Course item ${this.isCreate ? "created" : "updated"}`
        );

        this.$router.push({
          path: `/app/course/${this.course.id}/course-item`,
        });
      } catch (error) {
        this.loading = false;

        console.error("DEBUG: error", error);
        this.$store.dispatch("showSnackbar", "Oops, something went wrong!");
      }
    },
  },
  computed: {
    ...mapGetters([
      "getCourseLookup",
      "getItemTypes",
      "getCourseParentItems",
      "getCourseItems",
    ]),

    isCreate() {
      return _.get(this.$route, "meta.kind") === "create";
    },

    course() {
      return get(find(this.getCourseLookup, { course_id: +this.id }), "course");
    },

    parents() {
      const selections = [];

      selections.push({
        label: "Select Parent Course Item",
        value: 0,
      });

      this.getCourseParentItems.forEach((item) => {
        selections.push({
          label: item.header,
          value: item.id,
        });
      });

      return selections;
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-size: 16px;
  padding-left: 8px;
}
</style>
